import { render, staticRenderFns } from "./NewsWithImageCard.vue?vue&type=template&id=4489e7b0&scoped=true"
import script from "./NewsWithImageCard.vue?vue&type=script&lang=js"
export * from "./NewsWithImageCard.vue?vue&type=script&lang=js"
import style0 from "./NewsWithImageCard.vue?vue&type=style&index=0&id=4489e7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4489e7b0",
  null
  
)

export default component.exports